import { createJsonAdapter } from './jsonAdapter';
import { toMultipart } from '~/utils/helper/setupForm';

export interface IMedicalRecordRow {
  id: string;
  description: string;
  note?: string | null;
  type: string;
  file?: { id: string; name?: string; url?: string } | null;
}

// The record types the app lists under Senior Medical (NOTE was replaced by Emergency Contacts there).
export const MEDICAL_RECORD_TYPES = ['ALLERGY', 'HEALTH_HISTORY', 'TEST_RESULT'] as const;
export type MedicalRecordType = (typeof MEDICAL_RECORD_TYPES)[number];

const str = (value: unknown) => String(value ?? '').trim();

// Same fields as the app per type: Allergy = substance (description) + reaction (note), no file;
// Health History / Test Result = description + file, no note.
export const createMedicalRecordAdapter = (type: MedicalRecordType) => {
  const isAllergy = type === 'ALLERGY';

  return createJsonAdapter<IMedicalRecordRow>({
    url: 'medical-records',
    listParams: { type },
    rowToForm: (row) => ({
      description: row.description ?? '',
      note: row.note ?? '',
      // a string is the saved file's url; only a newly picked File is uploaded
      file: row.file?.url ?? '',
    }),
    toBody: (form, isCreate) =>
      toMultipart({
        // type is create-only: the update schema doesn't accept it
        type: isCreate ? type : undefined,
        description: str(form.description),
        note: isAllergy ? str(form.note) : undefined,
        file: !isAllergy && form.file instanceof File ? form.file : undefined,
      }),
  });
};
